module.exports = __webpack_public_path__ + "img/st4.8572972e.png";